import { extendTheme, Theme as BaseTheme } from '@chakra-ui/react';
import { breakpoints } from './breakpoints';
import { colors } from './colors';
import { components } from './components';
import { config } from './config';
import { radii } from './radii';
import { shadows } from './shadows';
import { sizes } from './sizes';
import { space } from './space';
import { styles } from './styles';
import { textStyles } from './textStyles';
import { typography } from './typography';

// chakra 1.6.7 loosened `extendTheme`'s typings making it so you can't derive the final type of your theme from it
// as a workaround, we merge the base theme type with our custom overrides

const overrides = {
  breakpoints,
  colors,
  components,
  config,
  radii,
  shadows,
  sizes,
  space,
  styles,
  textStyles,
  ...typography,
} as const;

export type Theme = BaseTheme & typeof overrides;

export const theme = extendTheme(overrides) as Theme;
